import { GzDashboardResetViewWebComponent } from './component/GzDashboardResetViewWebComponent';
export { GzDashboardResetViewWebComponent };
